module.exports = __webpack_public_path__ + "img/ai-narrative.4a07c399.svg";